import { IDirective } from 'angular';
import {
    IZippotamResponse,
} from '../../tn.billing/service.tn.billing';
import { Pricing } from '../../tn.pricing/service.tn.pricing';
import cartBodyTemplate from './cart-body.html';

// cart-body is used in cartReview, orderPlacement, and saved-cart-detail. The cart-body and cart-row directives rely on the controllers for these
// templated having specific properties.
//
// depends on parent controller having:
//     - vm.upgradedOrRenewalLicenses: unknown[]
//     - vm.newLicenses: unknown[]
//     - vm.sortByFamily: () => unknown
//     - vm.showEditPopover: () => unknown
//     - vm.purchaseWarning?: 'renewWarning; | 'hostedToSelfhostedWarning',
//     - vm.showPurchaseWarning: () => unknown
//     - vm.totals: {
//         oneTime: { base: number },
//         annual: { base: number },
//         threeYears: { base: number },
//         fiveYears: { base: number },
//         finals: { priceAdjustment: number }
//         subtotal: { base: number, discounted: number }
//         coupon: number,
//          finals: { withTax?: number }
//       }
//       vm.taxRate: { rate?: number }
//       vm.canGoToBilling: () => boolean
//
//     - vm.cart: { coupon?: { code} }
//     - vm.couponError?: string

export class CartBodyController {
    static $inject = ['tn.pricing.service'];

    constructor(protected pricingService: Pricing) {}

    onZipcodeChanged(zipcodeDetails: IZippotamResponse): void {
        const country = zipcodeDetails['country abbreviation'];
        const place = zipcodeDetails.places[0];
        const state = place['state abbreviation'];
        const zipcode = zipcodeDetails['post code'];
        // set the tax locale on the pricing service.
        this.pricingService.calculateTax(
            country,
            state,
            zipcode
        );
    }
}
export function CartBody(): IDirective {
    return {
        controller: CartBodyController,
        controllerAs: '$ctrl',
        template: cartBodyTemplate,
    };
}
